import React from 'react';
import ReactDOM from 'react-dom/client';
import { Amplify } from 'aws-amplify';
import posthog from 'posthog-js';
import App from './App';
import './index.css';
import awsConfig, { IS_CONFIGURED } from './config/aws-config';

// Initialisation i18n (doit être importé avant les composants)
import './i18n';

// PostHog Analytics
posthog.init('phc_qtLejzvjagJwrSzMl5K41jie6g24sKmFyPL8fU8Whkh', {
  api_host: 'https://eu.i.posthog.com',
  person_profiles: 'identified_only',
  capture_pageview: true,
  capture_pageleave: true,
});

// Configure Amplify seulement si le User Pool est configuré
if (IS_CONFIGURED) {
  Amplify.configure(awsConfig);
} else {
  console.warn('⚠️ Cognito non configuré. Créez un fichier .env avec VITE_USER_POOL_ID et VITE_USER_POOL_CLIENT_ID');
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

